import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

const stateSelector = state => ({
  ...state.commonReducer,
  ...state.userReducer,
});

export default function AppRouter() {
  const { appUpdateKey, userInfo } = useSelector(stateSelector);
  const { appRoutes } = $hooks.useTabletRouterUtils();

  return (
    <>
      <Switch key={appUpdateKey}>
        {appRoutes.map(menu => {
          return (
            <Route
              exact={menu.isExactPath}
              key={menu.path}
              path={menu.path}
              component={menu.component}
            />
          );
        })}
      </Switch>

      {/*TODO 간편비밀번호 새로고침 제거 커밋 금지 */}
      {!userInfo.isLoggedIn && <Redirect to="/login" />}
    </>
  );
}
